import {css, Menu, MenuItem, view} from '@sail/ui/deprecated';
import {FormattedMessage, useIntl} from 'react-intl';
import {useWidgetMenu} from '../useWidget';
import {HeaderMenuButton} from './HeaderMenuButton';
import {useTheme} from '../../ThemeProvider';

export function HeaderMenu() {
  const intl = useIntl();
  const {menuItems} = useWidgetMenu();
  const theme = useTheme();

  if (menuItems.length <= 0) {
    return null;
  }

  const menuOptions = menuItems.map((item) => {
    const {label} = item;
    let formattedLabel: React.ReactNode;
    let ariaLabel: string;
    if (typeof label === 'string') {
      formattedLabel = label;
      ariaLabel = label;
    } else {
      formattedLabel = <FormattedMessage {...label} />;
      ariaLabel = intl.formatMessage(label);
    }

    return (
      <MenuItem
        aria-label={ariaLabel}
        key={item.id}
        onAction={() => item.onPress()}
      >
        <view.span css={{color: css.value(theme.linkColor)}}>
          {formattedLabel}
        </view.span>
      </MenuItem>
    );
  });

  return (
    <view.div
      data-testid="conversations-widget-header-menu"
      css={{display: css.value('flex'), height: css.value('100%')}}
    >
      <Menu trigger={<HeaderMenuButton />}>{menuOptions}</Menu>
    </view.div>
  );
}
